var _defs, _rect, _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLightOnBold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;}.cls-2,.cls-3{stroke:#8fdef4;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Light_on_button_46") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 46,
    height: 46
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17,36.43l0-6.88a1.58,1.58,0,0,0-.71-1.33,12.45,12.45,0,1,1,13.45,0A1.58,1.58,0,0,0,29,29.55l0,6.88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17,39.12H29a0,0,0,0,1,0,0v1a3.77,3.77,0,0,1-3.77,3.77H20.8A3.77,3.77,0,0,1,17,40.08v-1A0,0,0,0,1,17,39.12Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 33.6,
    y1: 30.24,
    x2: 38.89,
    y2: 35.53
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 37.93,
    y1: 19.87,
    x2: 43.28,
    y2: 19.87
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2.72,
    y1: 19.87,
    x2: 8.07,
    y2: 19.87
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 33.4,
    y1: 6.83,
    x2: 39.03,
    y2: 1.21
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 12.4,
    y1: 30.24,
    x2: 7.11,
    y2: 35.53
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 8.07,
    y1: 19.87,
    x2: 3.75,
    y2: 19.87
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 12.6,
    y1: 6.83,
    x2: 6.97,
    y2: 1.21
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightOnBold);
export default __webpack_public_path__ + "static/media/icon_light_on_bold.025e5dace4b406edbddcb10ef2d3aef7.svg";
export { ForwardRef as ReactComponent };